import { render } from "./RegisterUserComponent.vue?vue&type=template&id=78f3fc6f&scoped=true"
import script from "./RegisterUserComponent.vue?vue&type=script&lang=js"
export * from "./RegisterUserComponent.vue?vue&type=script&lang=js"

import "./RegisterUserComponent.vue?vue&type=style&index=0&id=78f3fc6f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f3fc6f"]])

export default __exports__